import { getClientTypeFromKey } from '../utils/getClientTypeFromKey';

export const storeOrgUrlInSession = (key: string): void => {
  const sessionKey = getSessionKeyOrgUrl(key);

  sessionStorage.setItem(sessionKey, buildLoginUrl());
};

export const buildLoginUrl = (): string => {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;

  const orgUrl = `${encodeURIComponent(pathname + search + hash)}`;

  return orgUrl;
};

export const getSessionKeyOrgUrl = (key: string) => {
  const sessionKey = `nn.${getClientTypeFromKey(key)}.login.orgurl`;
  return sessionKey;
};
